import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionLabelProps {
    children: ReactNode
    index?: string
    className?: string
}

export const SectionLabel: FC<SectionLabelProps> = ({ children, index, className }): ReactNode => {
    return (
        <div className={cn('type-label flex items-center gap-3 text-muted-foreground', className)}>
            <span className='size-1.5 shrink-0 bg-ember' />

            {index && (
                <span className='text-foreground/70'>
                    {index}
                </span>
            )}

            <span>
                {children}
            </span>
        </div>
    )
}
